import { Logger, LogManager } from "../logger/logger";

export interface Property
{
    getBaseURLSecuirty():string;
    getBaseURL():string;
    getFlashURL(): string;
    getStreamingURL(): string;
    getAboutURL(): string;
    getSessionTimeout(): number;
    getEncryptionKey(): string;
    getTuneFileType(): string;
    getRefreshTokenDelta(): number;
    getFaceBookURL(): string;
    getTwitterURL(): string;
    getToneShareURL(): string;
    getPublicKey(): string;
    getLinkedinLink(): string;
    getFaceBookLink(): string;
    getInstagramLink(): string;
    getResendOtpTimeout(): string;
    getChannelId():string;
    setChannelId(channelId: string): void;
    getSelfCareFlashURL(): string;
    getRewardPointURL(): string;
    getRewardPointGenerateTokenURL(): string;
}

export class PropertyImpl implements Property 
{
    private logger: Logger = LogManager.getLogger(PropertyImpl.name);
    private properties: any;
    private channelId: string = "1";

    constructor()
    {
        this.logger.log("PropertyImpl() invoked");
    }
    getSelfCareFlashURL(): string {
        return this.properties["SELFCARE_FLASH_URL"];
    }

    setProperty(properties: any)
    {
        this.properties = properties;

        this.channelId = this.properties["CHANNEL_ID"];
    }

    getBaseURLSecuirty(): string {
        return this.properties["BASE_URL_SECURITY"];
    }

    getChannelId(): string {
        return this.channelId;
    }
    setChannelId(channelId: string): void {
        this.channelId = channelId;
    }
     
    getSessionTimeout(): number {
        return +this.properties["SESSION_TIMEOUT"];
    }

    getBaseURL(): string {
        return this.properties["BASE_URL"];
    }

    getAboutURL(): string {
        return this.properties["ABOUT_URL"];
    }

    getStreamingURL(): string {
        return this.properties["STREAMING_URL"];
    }

    getRefreshTokenDelta(): number {
        return this.properties["REFRESH_TOKEN_DELTA"];
    }
  
    getFaceBookURL(): string {
        return this.properties["FACEBOOK_SHAREURL"];
    }

    getResendOtpTimeout(): string {
        return this.properties["RESEND_OTP_TIMEOUT"];
    }

    getTwitterURL(): string 
    {
        return this.properties["TWITTER_SHAREURL"];
    }

    getLinkedinLink(): string {
        return this.properties["LINKEDIN_LINK"];
    }

    getFlashURL(): string
    {
        return this.properties["FLASH_URL"];
    }

    getFaceBookLink(): string {
        return this.properties["FACEBOOK_LINK"];
    }

    getPublicKey(): string {
        return "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6gB+nXg9M+KC8MYYOu/NRLmFg85LRrfRszyI/vZ/k8dANG9euxOB79FZ2f302hU+3joQZoJ3Sxq/GbIIFf/3y4f9DuKI53y1qR2qD4xIskfa9rPVqvBtAu2KSNRd8V4J8RKI2gT2YEA+A3Z0mQq4GBRS8iYmGLqRQyPfNUSankylBrTpOIVFBZORdZehjJMmwl98UMuVnJfIhuX6WWy9JJoc5WylPhOiHpjxWlndq1lErI7Tv2N93fD7nxt+siZryfazn3EAgBaTKTV/U5xIepzDN6ZYJ4qnC93u6erdb1X4m1zU6RGapwzCOPOORTyzw/uWJ8twcODNt0cqVp+sYQIDAQAB-----END PUBLIC KEY-----";
    }

    getInstagramLink(): string 
    {
        return this.properties["INSTAGRAM_LINK"];
    }

    getTuneFileType(): string {
        return this.properties["TUNE_FILE_TYPE"];
    }

    getToneShareURL(): string 
    {
        return this.properties["TONE_SHAREURL"];
    }

    getEncryptionKey(): string {
        return "secret key 123";
    }

    getRewardPointURL(): string
    {
        return this.properties["REWARD_POINT_URL"];
    }

    getRewardPointGenerateTokenURL(): string
    {
        return this.properties["REWARD_POINT_GENERATE_TOKEN_URL"];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/property/property.ts